export default __webpack_public_path__ + "static/media/Camping-cuate-min.7e2e8577.png";